module.exports = __webpack_public_path__ + "static/media/barba-bode_thumb.415e3f04.jpg";